import React from 'react';
import classes from '../List.module.scss';

interface ListFooterProps {
  children: React.ReactNode;
}
const ListFooter: React.FC<ListFooterProps> = ({ children }) => {
  return <div className={classes.listFooter}>{children}</div>;
};

export default ListFooter;
